var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-content",class:("type-" + _vm.type)},[_c('div',{staticClass:"news-title"},[_vm._v(_vm._s(_vm.newsCont.noticeTitle))]),_vm._v(" "),_c('div',{staticClass:"news-cont",domProps:{"innerHTML":_vm._s(_vm.newsCont.noticeContent)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-787d2136","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/news.vue
// module id = null
// module chunks = 